<template>
  <img ref="img" :class="className" alt="" :src="previewPath">
</template>

<script>
import { getImgBase64 } from '@/utils/imgBlobToBase64.js'
export default {
  props: {
    imageUrl: {
      type: String
    },
    token: {
      type: String
    },
    imageType: {
      type: String,
      default: 'view'
    },
    className: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      previewPath: ''
    }
  },
  watch: {
    imgUrl() {
      this.viewModel()
    }
  },
  mounted() {
    this.viewModel()
  },
  methods: {
    viewModel() {
      const that = this
      that.$nextTick(async() => {
        const viewUrl = that.imageUrl.startsWith('http://') ? that.imageUrl.replace(/http:\/\//, 'https://') : that.imageUrl
        console.log(viewUrl, 'viewUrl')
        that.previewPath = await getImgBase64(viewUrl, that.token)
        // downloadFile(viewUrl, that.token).then((res) => {
        //   that.previewPath = res
        // }).catch((err) => {
        //   console.log(err)
        // });
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tokenImage.vue